/* EditAction.js */

"use strict";
const _ = require("lodash");

class EditAction {
    constructor(logger, gameEditor, activeView, steveIo) {
        this._logger = logger;
        this._activeView = activeView;
        this._fileFactory = steveIo.fileFactory;
        this._gameEditor = gameEditor;
        this.run = this.run.bind(this);
    }
    run() {
        return Promise.resolve().then(() => {
            let selectedImageIds = _.get(
                this._activeView.getSelectedImageIds(),
                "selectedRows",
                []
            );
            if (selectedImageIds.length) {
                this._activeView.openFileManagerInstanceEditor(selectedImageIds);
            }
        });
    }
}
module.exports = EditAction;

EditAction.$inject = ["$teve.logger", "gameEditor.gameEditor", "gameEditor.activeView", "$teve.io"];

EditAction.$displayDetails = {
    type: "Action",
    name: "EditAction",
    icon: "common.multi_edit",
    shown: true,
    title: "Edit File",
    order: 4,
};
